import * as React from "react"
import {SvgFunction} from "@web-libs/ui/svgs/types";
import {withColor} from "@web-libs/ui/svgs/fill/with-color";
const _Checkmark: SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 12}
        height={props.height ?? 12}
        viewBox="0 0 12 12"
        className={props.className}
    >
        <g clipPath="url(#a)">
            <path
                fill={props.fill}
                d="M3.875 10.331c-.341 0-.668-.135-.908-.376L.222 7.211a.757.757 0 0 1 1.07-1.07l2.583 2.583 6.834-6.834a.757.757 0 0 1 1.07 1.07L4.782 9.955c-.241.241-.568.377-.908.376Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
)

export {_Checkmark}

const Checkmark = withColor(_Checkmark)

export default Checkmark
